import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card'
import CountdownTimer from './countdownTimer';

const TimerCountdown = () => {
    return ( 
        <div>
        <Row className="justify-content-center mt-5 mb-5">
            <Card style={{ width: '45rem' }} className='d-flex justify-content-center"'>
              <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center">
                <h3>Time is Counting Down...</h3>
                <Card.Text>
                  <CountdownTimer />
                  ...Until the festivities begin on October 10, 2026!
                </Card.Text>
              </Card.Body>
            </Card>
          </Row>
        </div>
     );
}
 
export default TimerCountdown;
